import Vue from 'vue';
import App from './App';
import router from './router';

import BootstrapVue from 'bootstrap-vue';

import store from './_store';
import globals from './globals';
import Popper from 'popper.js';

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false;

Vue.config.productionTip = false;

Vue.use(BootstrapVue);

// Global RTL flag
Vue.mixin({
  data: globals
});

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
